/** Settings come back as "7:00" / "20:00" — pad so both ends read alike. */
export const formatTime = (value?: string | null) => {
  if (!value) return null;
  const [hours, minutes = "00"] = value.trim().split(":");
  if (!hours) return null;
  return `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}`;
};

/**
 * The backend only enforces the alert window when `restrict_alert_hours` is
 * on. The value is a real boolean server-side but typed as a string in the
 * init payload, so "false" has to be rejected explicitly.
 */
export const isAlertScheduleRestricted = (value: unknown) =>
  value === true || value === "true";
